export default __webpack_public_path__ + "static/media/2Schrodinger_schat.8976b275.png";